/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
import Amazon from "../../../src/components/amazon";
import Hatena from "../../../src/components/hatena";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    ul: "ul",
    li: "li"
  }, _provideComponents(), props.components);
  return React.createElement(React.Fragment, null, React.createElement(_components.p, null, "改造版AozoraEpub3　1.1.1b23Q (2024/03/10)"), "\n", React.createElement(_components.ul, null, "\n", React.createElement(_components.li, null, "リファクタリング等"), "\n", React.createElement(_components.li, null, "ユーザーエージェントを設定可能にした"), "\n"), "\n", React.createElement(Hatena, {
    src: "https://github.com/kyukyunyorituryo/AozoraEpub3/releases/tag/v1.1.1b23Q",
    title: ""
  }), "\n", React.createElement(_components.p, null, "バグが出ても対応できる人向け"), "\n", React.createElement(_components.p, null, "web/ncode.syosetu.com/extract.txt、web/novel18.syosetu.com/extract.txt"), "\n", React.createElement(_components.p, null, "内の#USER_AGENT\r\nの#を外してユーザーエージェントを書き換えれる"));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
